import { registerLocaleData } from '@angular/common';
import localeNlBe from '@angular/common/locales/nl-BE';
import { Injectable } from '@angular/core';

@Injectable()
export class LocaleService {
    init(): void {
        return registerLocaleData(localeNlBe);
    }
}
